import Reflux, { RefluxAction } from "reflux";

const _moduleExport: RefluxAction<any> = Reflux.createAction({
    asyncResult: true
});

export default _moduleExport;
